import React, { FC, useEffect, useState } from 'react';

import s from './DesktopApp.scss';

import { reportLoadSuccess } from '../../utils/bi';
import { monitoring } from '../../utils/monitoring';

import { InfoPopUp } from '../InfoPopUp/InfoPopUp';
import { TemplateDemo } from '../TemplateDemo/TemplateDemo';
import { ToolBar } from '../ToolBar/ToolBar';
import { WixStudioToolBar } from '../WixStudioNewToolBar/WixStudioToolBar';
import { WixStudioTemplateDemo } from '../WixStudioTemplateDemo/WixStudioTemplateDemo';

import { useTemplateContext } from '../../context/TemplateContext';
import { useUIContext } from '../../context/UIContext';
import { desktopAppDataHooks } from './DesktopApp.dataHooks';
import { TemplateModal } from '../TemplateModal';
import { useUserData } from '../../context/UserDataContext';

export const DesktopApp: FC = () => {
  const { viewMode, toggleViewMode, isInfoShown } = useUIContext();
  const template = useTemplateContext();
  const { isStudio, desktop16X9Image, editorUrl } = template;
  const userData = useUserData();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const isModalShown = !!Number(window?.localStorage?.getItem?.('newEditModal'));
    const isWixelDashboard = new URLSearchParams(window?.location?.search).get('sourceContext') === 'wixelDashboard';
    if (!isOpen && !isModalShown && !isWixelDashboard) {
      window?.localStorage?.setItem?.('newEditModal', '1');
      const t = setTimeout(() => setIsOpen(true), userData.isLoggedIn ? 1000 : 8000);
      return () => {
        clearTimeout(t);
      };
    }
  }, [isOpen, userData.isLoggedIn]);

  useEffect(() => {
    reportLoadSuccess();
    monitoring.appLoaded();
  }, []);

  useEffect(() => {
    document.body.classList.toggle('popup', isInfoShown);
  }, [isInfoShown]);

  return (
    <>
      {isStudio ? (
        <div className={s.studioRoot}>
          <WixStudioToolBar
            viewMode={viewMode}
            toggleViewMode={toggleViewMode}
            dataHook={desktopAppDataHooks.wixStudioNewToolbar}
          />
          <WixStudioTemplateDemo
            template={template}
            viewMode={viewMode}
            dataHook={desktopAppDataHooks.wixStudioTemplateDemo}
          />
        </div>
      ) : (
        <>
          <ToolBar />
          <TemplateDemo />
          <InfoPopUp dataHook={desktopAppDataHooks.infoPopUp} />
        </>
      )}
      {isOpen && (
        <TemplateModal editorUrl={editorUrl} isOpen image={desktop16X9Image} onClose={() => setIsOpen(false)} />
      )}
    </>
  );
};
